class LSG5050ScrollingModule extends HTMLElement {
    constructor() {
        super();
        this.initializeElements();
        this.bindEvents();
        this.init();
    }

    /**
     * Initialize DOM elements
     */
    initializeElements() {
        this.contentItems = this.querySelectorAll('.js-content-item');
        this.mediaItems = this.querySelectorAll('.js-media-item');
        this.fadeOverlay = this.querySelector('.js-fade-overlay');
        this.sectionModule = this.querySelector('.js-section-module');
        this.isSmallScreen = window.matchMedia("(max-width: 1024px)").matches;
        this.lastActiveIndex = 0;
    }

    /**
     * Bind event listeners
     */
    bindEvents() {
        if (this.contentItems.length > 1 && !this.isSmallScreen) {
            window.addEventListener('scroll', this.checkDistanceFromTop.bind(this));
        }

        if (this.fadeOverlay) {
            window.addEventListener('scroll', this.handleFadeOverlay.bind(this));
        }

        window.addEventListener('scroll', this.pauseVideosOutsideViewport.bind(this));

        if (this.isSmallScreen) {
            window.addEventListener('scroll', this.handleSmallScreenVideoPlayback.bind(this));
        }

        this.mediaItems.forEach((item, index) => {
            const playButton = item.querySelector('.js-play-video-btn');
            const pauseButton = item.querySelector('.js-pause-video-btn');

            if (playButton && pauseButton) {
                playButton.addEventListener('click', () => this.playVideo(index));
                pauseButton.addEventListener('click', () => this.pauseVideo(index));
            }
        });
    }

    /**
     * Initialize the component
     */
    init() {
        // Ensure the first item has 'active' class on page load
        if (this.mediaItems.length > 0 && this.contentItems.length > 0) {
            this.mediaItems[0].classList.add('active');
            this.contentItems[0].classList.add('active');
        }

        // Move elements for small screens
        if (this.isSmallScreen) {
            this.contentItems.forEach((item, index) => {
                const mediaContent = this.mediaItems[index].querySelector('.js-media-content');
                const titleGroup = item.querySelector('.js-title-group');
                const descGroup = item.querySelector('.js-desc-group');

                if (mediaContent && titleGroup && descGroup) {
                    mediaContent.insertBefore(titleGroup, mediaContent.firstChild);
                    mediaContent.appendChild(descGroup);
                }
            });
        }

        // Initialize the fade overlay
        this.handleFadeOverlay();
    }

    /**
     * Check distance from top on scroll
     */
    checkDistanceFromTop() {
        let anyVisible = false; // Flag to check if any element is visible

        this.contentItems.forEach((item, index) => {
            const distanceFromTop = item.getBoundingClientRect().top;

            if (distanceFromTop >= 0 && distanceFromTop <= 100) {
                this.activateItem(index);
                anyVisible = true;
            } else if (index === this.lastActiveIndex) {
                // Keep the last active item active
                this.activateItem(this.lastActiveIndex);
                anyVisible = true;
            } else {
                this.deactivateItem(index);
            }
        });

        // If no element is visible, keep the last active element active
        if (!anyVisible && this.mediaItems.length > 0 && this.contentItems.length > 0) {
            this.activateItem(this.lastActiveIndex);
        }
    }

    /**
     * Activate an item
     */
    activateItem(index) {
        this.mediaItems[index].classList.add('active');
        this.contentItems[index].classList.add('active');
        this.lastActiveIndex = index;

        // Play video if present
        const video = this.mediaItems[index].querySelector('video');
        if (video) {
            video.play();
            this.toggleVideoButtons(index, true);
        }
    }

    /**
     * Deactivate an item
     */
    deactivateItem(index) {
        this.mediaItems[index].classList.remove('active');
        this.contentItems[index].classList.remove('active');

        // Pause video if present
        const video = this.mediaItems[index].querySelector('video');
        if (video && !video.paused) {
            video.pause();
            this.toggleVideoButtons(index, false);
        }
    }

    /**
     * Play video at index
     */
    playVideo(index) {
        const video = this.mediaItems[index].querySelector('video');
        if (video) {
            video.play();
            this.toggleVideoButtons(index, true);
        }
    }

    /**
     * Pause video at index
     */
    pauseVideo(index) {
        const video = this.mediaItems[index].querySelector('video');
        if (video) {
            video.pause();
            this.toggleVideoButtons(index, false);
        }
    }

    /**
     * Toggle video play/pause buttons
     */
    toggleVideoButtons(index, isPlaying) {
        const playButton = this.mediaItems[index].querySelector('.js-play-video-btn');
        const pauseButton = this.mediaItems[index].querySelector('.js-pause-video-btn');

        if (isPlaying) {
            playButton.classList.remove('active');
            pauseButton.classList.add('active');
        } else {
            playButton.classList.add('active');
            pauseButton.classList.remove('active');
        }
    }

    /**
     * Handle fade overlay based on section module bottom edge
     */
    handleFadeOverlay() {
        if (this.fadeOverlay) {
            const sectionBottom = this.sectionModule.getBoundingClientRect().bottom;
            const viewportHeight = window.innerHeight;

            if (sectionBottom <= viewportHeight && sectionBottom >= 0) {
                this.fadeOverlay.classList.add('inActive');
            } else {
                this.fadeOverlay.classList.remove('inActive');
            }
        }
    }

    /**
     * Pause all videos
     */
    pauseAllVideos() {
        this.mediaItems.forEach((item, index) => {
            const video = item.querySelector('video');
            if (video && !video.paused) {
                video.pause();
                this.toggleVideoButtons(index, false);
            }
        });
    }

    /**
     * Pause videos outside the viewport
     */
    pauseVideosOutsideViewport() {
        const sectionTop = this.sectionModule.getBoundingClientRect().top;
        const sectionBottom = this.sectionModule.getBoundingClientRect().bottom;
        const viewportHeight = window.innerHeight;

        if (sectionTop >= viewportHeight || sectionBottom <= 0) {
            this.pauseAllVideos();
        }
    }

    /**
     * Handle video playback for small screens
     */
    handleSmallScreenVideoPlayback() {
        this.mediaItems.forEach((item, index) => {
            const video = item.querySelector('video');
            if (video) {
                const rect = item.getBoundingClientRect();
                if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                    video.play();
                    this.toggleVideoButtons(index, true);
                } else {
                    video.pause();
                    this.toggleVideoButtons(index, false);
                }
            }
        });
    }
}

customElements.define('lsg-50-50-scrolling-module', LSG5050ScrollingModule);
